import { useNavigate } from "react-router-dom";
import { PROFILE_IMG_BASE } from "@config/env";
import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";
import AvailabilityRing from "@common/AvailabilityRing";

const COLORS = ["#2563EB","#7C3AED","#16A34A","#D97706","#EF4444"];

export default function MyFavourites({ favorites = [], firmId, loading }) {
  const navigate = useNavigate();

  return (
    <DashboardSectionCard title="My Favourites" subtitle="Starred candidate profiles" icon="fa-star" colorKey="amber">
      {loading ? (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {[1,2,3].map(i => (
            <div key={i} style={{ background:"var(--fc-bg-light)", borderRadius:10, padding:"11px 13px", display:"flex", gap:12, alignItems:"center" }}>
              <div style={{ width:3, height:36, borderRadius:99, background:"var(--fc-border-strong)", flexShrink:0 }} />
              <div style={{ width:32, height:32, borderRadius:99, background:"var(--fc-border-light)", flexShrink:0 }} />
              <div style={{ flex:1 }}>
                <div style={{ height:12, background:"var(--fc-border-light)", borderRadius:4, width:"50%", marginBottom:6 }} />
                <div style={{ height:10, background:"var(--fc-border-light)", borderRadius:4, width:"70%" }} />
              </div>
            </div>
          ))}
        </div>
      ) : !favorites.length ? (
        <EmptyState icon="fa-star" text="No favourites yet" sub="Star a profile to save it here" actionLabel="Search candidates" actionTo="/search" />
      ) : (
        <div className="fc-scroll-container" style={{ overflowY:"auto", overflowX:"hidden", maxHeight:280, scrollbarWidth:"none" }}>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {favorites.slice(0, 5).map((f, i) => {
              const isOwn  = firmId && firmId === f.firm_id;
              const name   = isOwn ? (f.profile_name || f.full_name || f.name || `${f.first_name||""} ${f.last_name||""}`.trim() || "—") : "Name Withheld";
              const role   = f.user_profile_role || f.role || "";
              const slug   = f.resource_slug || f.user_slug || f.id;
              const img    = isOwn && f.profile_image_path ? PROFILE_IMG_BASE + f.profile_image_path : null;
              const color  = COLORS[i % COLORS.length];

              return (
                <div key={i}
                  onClick={() => navigate(`/resources/details/${slug}`)}
                  style={{ background:"var(--fc-bg-light)", border:"1px solid var(--fc-border-light)", borderRadius:10, padding:"11px 13px", cursor:"pointer", transition:"all 0.15s", display:"flex", alignItems:"center", gap:12 }}
                  onMouseEnter={e=>{ e.currentTarget.style.background="var(--fc-amber-light)"; e.currentTarget.style.borderColor="var(--fc-amber-border)"; }}
                  onMouseLeave={e=>{ e.currentTarget.style.background="var(--fc-bg-light)"; e.currentTarget.style.borderColor="var(--fc-border-light)"; }}>

                  {/* Accent bar */}
                  <div style={{ width:3, height:36, borderRadius:99, background:color, flexShrink:0 }} />

                  {/* Avatar */}
                  <div style={{ width:32, height:32, borderRadius:99, background:color+"18", border:`1.5px solid ${color}30`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
                    {img
                      ? <img src={img} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} onError={e=>e.target.style.display="none"} />
                      : <i className="fa-solid fa-user" style={{ fontSize:12, color:"var(--fc-text-subtle)" }} />
                    }
                  </div>

                  {/* Info */}
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:isOwn?"var(--fc-text-primary)":"var(--fc-text-subtle)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:3 }}>
                      {name}
                    </div>
                    {role && (
                      <div style={{ fontSize:11, fontWeight:600, color:"var(--fc-text-secondary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", display:"flex", alignItems:"center", gap:3 }}>
                        <i className="fa-solid fa-briefcase" style={{ fontSize:8, color:"var(--fc-text-subtle)" }}/>{role}
                      </div>
                    )}
                  </div>

                  {/* Availability */}
                  {isOwn && f.availability != null && (
                    <AvailabilityRing value={f.availability} size={38} />
                  )}
                  <i className="fa-solid fa-star" style={{ fontSize:11, color:"#FCD34D", flexShrink:0 }} />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </DashboardSectionCard>
  );
}